module.exports = __webpack_public_path__ + "static/documente-administrare-imobile.dce09d4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/documente-administrare-imobile.jpg
// module id = 460
// module chunks = 35783957827783